import { useEffect, useState } from "react";
import api from "../lib/api";
import ProUpgradeTour from "./ProUpgradeTour";

/**
 * Mounts the Pro upgrade welcome tour exactly once per Pro owner,
 * automatically deciding whether it's appropriate to surface.
 *
 * Trigger conditions (all true):
 *   - owner is Pro
 *   - pro_onboarding_tour_dismissed_at is NOT set
 *
 * Renders nothing if the tour shouldn't show — so the dashboard can
 * mount it unconditionally without polluting the layout.
 */
export default function ProUpgradeTourLauncher() {
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    queueMicrotask(async () => {
      try {
        const { data } = await api.get("/owner/pro-tour-status");
        if (!cancelled) setStatus(data);
      } catch {
        if (!cancelled) setStatus(null);
      }
    });
    return () => { cancelled = true; };
  }, []);

  if (!status || dismissed) return null;
  if (!status.should_show) return null;

  return <ProUpgradeTour name={status.name} onDismiss={() => setDismissed(true)} />;
}
